<div id="notification-backdrop" (click)="backdropClick($event)">
  <div class="notification-container" id="notifications">
    <div class="notification-header">
      <div class="row">
        <div class="col-9">
          <span class="title">You have {{newNotificationCount}} new notifications</span>
        </div>
        <div class="col-3 text-right" *ngIf="modifiedNotifications.length > 0">
          <span class="clear-all" (click)="clearAllNotification()">Clear All</span>
        </div>
      </div>
    </div>
    <div class="notification-content" *ngFor="let notification of modifiedNotifications">
      <div class="row m-0">
        <div class="col-12 notification-date p-0">{{notification?.date}}</div>
        <div class="col-12 notification-box" *ngFor="let notify of notification.notification"
          [ngClass]="notify?.isNew ? 'new-notification' : 'old-notification'"> 
          <!-- (click)="notificationClickHandler(notify)"> -->
          <div class="row">
            <div class="col-12 notification-time">
              <div class="new" *ngIf="notify?.isNew"></div>
              <span class="time">{{getTimeFromISO(notify?.createdDate)}}</span>
            </div>
            <div class="col-12 notification-text">
              <span>{{notify?.message}} </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
